import React, { useState, useEffect, useMemo } from 'react';
import PageHeading from '../../components/PageHeading';
import { SearchOutlined, EditOutlined, DeleteOutlined, AlipayOutlined, ClockCircleOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axios';
import { Alert, Button, Input, message, Popconfirm, Table } from 'antd';
import { dateFormat } from '../../utils/dateFormats';
import TimeSlotModal from './TimeSlotModal';

const TimeSlot = () => {
	const [timeslots, setTimeslots] = useState([]);
	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState('');
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [selectedId, setSelectedId] = useState(null);

	useEffect(() => {
			fetchData();
	}, []);

	const openModalUpdate = (id) => {
		setSelectedId(id);
		setCreateModalOpen(true);
	};

	const openModalCreate = () => {
		setSelectedId(null);
		setCreateModalOpen(true);
	};

	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get("core/timeslot/");
			setTimeslots(response.data);
		} catch (error) {
			message.error("Failed to fetch timeslots");
		} finally {
			setLoading(false);
		}
	};

	const cancel = () => message.info('Cancelled');

	const confirm = async (id) => {
		try {
			await axiosInstance.delete(`core/timeslot/${id}/`);
			message.success("Deleted successfully");
			setTimeslots(prev => prev.filter(item => item.id !== id));
		} catch (err) {
			message.error("Cannot delete");
		}
	};

	const filteredlanguages = useMemo(() => {
			return timeslots.filter(item =>
					item.title.toLowerCase().includes(search.toLowerCase())
			);
	}, [search, timeslots]);

	const columns = [
	{
		title: 'Title',
		dataIndex: 'title',
		key: 'title',
	},
	{
		title: 'Start Time',
		dataIndex: 'start_time',
		key: 'start_time',
	},
	{
		title: 'End Time',
		dataIndex: 'end_time',
		key: 'end_time',
	},
	{
		title: 'Action',
		dataIndex: '',
		key: 'actions',
		render: (_, record) => record.restricted ? null : (
			<>
				<Button type="link" icon={<EditOutlined />}  onClick={() => openModalUpdate(record.id)} />
				<Popconfirm
					title="Delete"
					description="Are you sure to delete this item?"
					onConfirm={() => confirm(record.id)}
					onCancel={cancel}
					okText="Yes"
					cancelText="No"
				>
					<Button type="link" danger icon={<DeleteOutlined />} />
				</Popconfirm>
			</>
		)
	},
];

	return (
		<div className='dashboard'>
			<PageHeading name="Time Slots" icon={<ClockCircleOutlined />} />
			<Alert type='warning' message='Important Note' description="Do not delete timeslot if it is connected to any show which is under booking"/>
			<br/>
			<div style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '12px',
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: 16
			}}>
				<Input
					placeholder="Search here"
					prefix={<SearchOutlined />}
					style={{ width: "190px" }}
					onChange={(e) => setSearch(e.target.value)}
				/>
				<Button type="primary" onClick={openModalCreate}>Add new</Button>
			</div>

			<Table
				dataSource={filteredlanguages}
				loading={loading}
				columns={columns}
				rowKey="id"
				pagination
			/>

			<TimeSlotModal
				open={createModalOpen}
				setOpen={setCreateModalOpen}
				timeslots={timeslots}
				setTimeslots={setTimeslots}
				selectedId={selectedId}
			/>
		</div>
	)
}

export default TimeSlot
